import storage from 'store'
import { base64Encode, base64Decode } from '@/utils/crypto'
import { ACCESS_TOKEN, LAST_OPER_TIME } from '@/store/mutation-types'
import { loginForPassword, loginForSmsCode, logout } from '@/api/user'
import { getUserInfo } from '@/api/security'
const user = {
  state: {
    token: '',
    userId: '',
    userName: '',
    welcome: '',
    avatar: '',
    depts: [],
    roles: [],
    config: {},
    info: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
    SET_DEPTS: (state, depts) => {
      state.depts = depts
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CONFIG: (state, config) => {
      state.config = config
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },
  actions: {
    LoginForPassword ({ commit }, data) {
      return new Promise((resolve, reject) => {
        loginForPassword(data).then(res => {
          const result = res.result
          commit('SET_TOKEN', base64Encode(result.access_token))
          storage.set(ACCESS_TOKEN, base64Encode(result.access_token))
          storage.set(LAST_OPER_TIME, new Date().getTime())
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginForSmsCode ({ commit }, data) {
      return new Promise((resolve, reject) => {
          loginForSmsCode(data).then(res => {
            const result = res.result
            commit('SET_TOKEN', base64Encode(result.access_token))
            storage.set(ACCESS_TOKEN, base64Encode(result.access_token))
            storage.set(LAST_OPER_TIME, new Date().getTime())
            resolve()
          }).catch(error => {
            reject(error)
          })
      })
    },
    GetUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          const result = res.result
          commit('SET_CONFIG', result.userConfig)
          commit('SET_DEPTS', result.userDepts)
          commit('SET_ROLES', result.userRoles)
          commit('SET_INFO', result.userBase)
          commit('SET_USER_NAME', result.userBase.nickName)
          commit('SET_USER_ID', result.userBase.userId)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({access_token: base64Decode(state.token)}).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_ID', '')
          commit('SET_USER_NAME', {})
          commit('SET_DEPTS', [])
          commit('SET_ROLES', [])
          commit('SET_CONFIG', {})
          commit('SET_INFO', {})
          storage.remove(ACCESS_TOKEN)
          storage.remove(LAST_OPER_TIME)
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
  }
}

export default user